module.exports = __webpack_public_path__ + "static/media/Scene 1(2).4c63e52a.jpg";